import { SvgIcon } from '@material-ui/core'

export default function StopIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <rect x="7" y="7" width="10" height="10" rx="2" fill="currentColor" />
        </SvgIcon>
    )
}
